// Relative imports
import { addQueryParams, axiosInstance } from "./common.jsx";

export const getOperators = async () => {
  const endpoint = "operators/";
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getOperatorInfoById = async (operator_id) => {
  const endpoint = `operators/${operator_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateOperator = async (operator_id, data) => {
  const endpoint = `operators/${operator_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const listUserOperatorsInstances = async () => {
  const endpoint = "operators/user-instances";
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const inviteOperator = async (data) => {
  const endpoint = "operators/invitation/";
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const listInvitedOperators = async (queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || "operators/invitation/";
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const editOperator = async (operator_id, data) => {
  const endpoint = `operators/${operator_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
